import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    aosConfig,
    addScollClass,
    addParalax,
    addFancyboxFixForGallery,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService
} from './functions';

import gsap from "gsap";


const mainApp = () => {



    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    aosConfig();

    // add scroll class to body  
    addScollClass('0px', 'scroll');

    // add paralax to element
    addParalax('.paralax');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.blocks-gallery-grid');

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();


}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.indexC2__box.b1, .showGermanyTrigger').click(function () {
            $('.mainHeader__menu li').removeClass('hover');
            $('.mainHeader__menu li.showGermany').addClass('hover');
            return false;
        });
        $('.indexC2__box.b2, .indexC2__box.b3,.indexC2__box.b4, .showOtherLangTrigger').click(function () {
            $('.mainHeader__menu li').removeClass('hover');
            $('.mainHeader__menu li.showOtherLang').addClass('hover');
            return false;
        });
        $('.mainHeader__menu').mouseenter(function () {
            $('.mainHeader__menu li').removeClass('hover');
        });

        if ($('input[name="formCourseTestLink"]').length > 0) {
            $('.forTestScore a').attr('href', $('input[name="formCourseTestLink"]').val());
        }



        //rotator and sliders
        if ($('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: false,
                dots: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 5000,
                fade: true,
                cssEase: 'linear'
            });
            var currentRotSlide = 0;
            $('.rotatorTop').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                currentRotSlide = currentSlide;
                $('.rotatorTop .rotator__slide:nth-child(' + (currentSlide + 1) + ')').addClass('slick-out');
            });
            $('.rotatorTop').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                $('.rotatorTop .rotator__slide:nth-child(' + (currentRotSlide + 1) + ')').removeClass('slick-out');
            });
        }

        if ($('.indexC6__slider').length > 0) {
            $('.indexC6__slider').slick({
                infinite: false,
                arrows: false,
                dots: true,
                autoplay: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 5000,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    },

                ]
            });

        }

        if ($('.indexC7__slider').length > 0) {
            $('.indexC7__slider').slick({
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                slidesToShow: 7,
                slidesToScroll: 1,
                speed: 5000,
                autoplaySpeed: 0,
                centerMode: true,
                // variableWidth: true,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 560,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 420,
                        settings: {
                            slidesToShow: 1,
                        }
                    },

                ]

            });

        }



        if ($('.wp-block-gallery').length > 0) {

            $('.wp-block-gallery').each(function (i) {
                const h3 = $(this).find('.blocks-gallery-caption').text();
                let newGallery = $('<div class="newGallery">' +
                    (h3 != '' ? '<h3 class="newGallery__header">' + $(this).find('.blocks-gallery-caption').text() + '</h3>' : '') +
                    '<div  class="newGallery__slider mySlider slickSliderUi"></div></div>');



                let tempItem = '';
                let gallery = $(this).find('figure');
                gallery.each(function (index) {

                    tempItem += $(this).html();
                    let newItem = $('<div class="newGallery__slide"></div>');
                    newItem.append(tempItem);
                    newGallery.find('.newGallery__slider').append(newItem);
                    tempItem = '';

                });
                $(this).before(newGallery);
                var idGal = 'gal' + (Math.floor(Math.random() * 100));
                newGallery.find('a').each(function () {
                    $(this).attr('data-fancybox', idGal);
                    $(this).find('img').removeAttr('loading');
                    $(this).attr('data-caption', $(this).next('figcaption').html());

                });
                $(this).remove();

            });



        }

        $('.newGallery__slider').slick({
            infinite: false,
            arrows: false,
            dots: true,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 3000,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });





        //fancybox
        $(".blocks-gallery-item a, .fancybox, .wp-block-image a, .newGallery__slider a").fancybox({
            'loop': true,
            'margin': [44, 0],
            'gutter': 50,
            'keyboard': true,
            'arrows': true,
            'infobar': false,
            'toolbar': true,
            'buttons': ["slideShow", "fullScreen", "close"],
            'idleTime': 4,
            'protect': false,
            'modal': false,
            'animationEffect': "fade",
            'animationDuration': 600,
            'transitionEffect': "fade",
            'transitionDuration': 800,
            backFocus: false,
            thumbs: {
                autoStart: true, // Display thumbnails on opening
                hideOnClose: true, // Hide thumbnail grid when closing animation starts
                parentEl: ".fancybox-container", // Container is injected into this element
                axis: "y" // Vertical (y) or horizontal (x) scrolling
            }
        });


        $('body *[href*="*!*"]').each(function () {
            $(this).attr('href', $(this).attr('href').replace('*!*', '@'));
        });

        $('body').find(":contains('*!*'):not(:has(*))").each(function () {
            $(this).html($(this).html().replace(/\*!\*/gim, '@'));
        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



